import { Box, BoxProps } from "@chakra-ui/react";
import { IKeyFigureGroup } from "src/api/server/extended-search";
import { WfHeading } from "src/components/base/wf-heading";
import { RangeSliderList } from "src/components/pages/search/components/key-figures-filter/components/range-slider-list";
import { ISearch } from "src/components/pages/search/search.types";

interface IKeyFiguresGroup extends ISearch, BoxProps {
    keyFiguresGroup: IKeyFigureGroup;
}

export const KeyFiguresGroup = ({ keyFiguresGroup, onSearch, ...boxProps }: IKeyFiguresGroup) => {
    return (
        <Box {...boxProps}>
            {keyFiguresGroup.headline && (
                <WfHeading as="h2" fontSize={["sm", "md"]} pb={1}>
                    {keyFiguresGroup.headline}
                </WfHeading>
            )}
            <RangeSliderList keyFiguresData={keyFiguresGroup.keyFigures} onSearch={onSearch} />
        </Box>
    );
};
